import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
import { setInteractionMode } from "vee-validate";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import Layout from "@/router/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import DeleteComponent from "@/components/deleteComponent.vue";
import { HighlightModule } from "@/store/modules/highlights.module";
import { interpret } from "xstate";
import highlightMachine from "./machines/highlightsMachine";
import EcGrid from "@/components/widgets/EcGrid.vue";
setInteractionMode("passive");
Component.registerHooks(["metaInfo", "beforeRouteEnter"]);
let Highlights = /** @class */ (() => {
    let Highlights = class Highlights extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "Highlights";
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Masters",
                    href: "#",
                },
                {
                    text: "Highlights",
                    href: "#",
                },
            ];
            this.isGridLoading = false;
            this.initialPage = 1;
            this.initialPageSize = 10;
            this.totalCount = 0;
            this.selectedDate = null;
            this.formatedDate = "";
            this.highlightId = "";
            this.isPageIsDirty = false;
            this.statuses = ["Active", "Draft", "Archived"];
            this.machine = highlightMachine.withContext({
                searchData: {
                    page: 1,
                    pageSize: 10,
                    sort: {
                        field: "publishDateAsString",
                        type: "desc",
                    },
                    columnFilters: [],
                },
                ispageChanged: false,
            });
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
            this.serverParams = {
                columnFilters: {},
                sort: {
                    field: "publishDateAsString",
                    type: "desc",
                },
                page: 1,
                pageSize: 10,
            };
            this.initialSortBy = {
                field: "publishDateAsString",
                type: "desc",
            };
            this.columns = [
                {
                    field: "name",
                    label: "Name",
                    thClass: "",
                    sortable: true,
                    filterOptions: {
                        enabled: true,
                        placeholder: "Name",
                    },
                },
                {
                    field: "publishDateAsString",
                    label: "Date of Publish",
                    sortable: true,
                    isDatePicker: true,
                    filterOptions: {
                        enabled: true,
                    },
                },
                {
                    field: "status",
                    label: "Status",
                    sortable: false,
                    filterOptions: {
                        enabled: true,
                        filterDropdownItems: [],
                    },
                },
                {
                    field: "actions",
                    label: "Actions",
                    thClass: "master-action text-center",
                    tdClass: "no-row-click",
                    sortable: false,
                },
            ];
        }
        send(event) {
            this.machineService.send(event);
        }
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        }
        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
            this.loadItems();
        }
        onPerPageChange(params) {
            if (!this.isPageIsDirty) {
                this.initialPage = 1;
            }
            this.updateParams({
                pageSize: params.currentPerPage,
                page: this.initialPage,
            });
            this.loadItems();
        }
        onSortChange(params) {
            if (!this.isPageIsDirty) {
                this.initialPage = 1;
            }
            this.updateParams({ sort: params[0], page: this.initialPage });
            this.loadItems();
        }
        onDateChanged(item) {
            this.initialPage = 1;
            this.serverParams.page = this.initialPage;
            this.selectedDate = item;
            this.loadItems();
        }
        onColumnFilter(params) {
            if (!this.isPageIsDirty) {
                this.initialPage = 1;
            }
            this.updateParams({
                columnFilters: params.columnFilters,
                page: this.initialPage,
            });
            this.loadItems();
        }
        loadItems() {
            this.isGridLoading = true;
            var filters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({
                    name: key,
                    value: value,
                });
            });
            if (this.selectedDate != null) {
                filters.push({
                    name: "publishDateAsString",
                    value: `${this.selectedDate}`,
                });
            }
            else {
                if (!this.isPageIsDirty) {
                    filters.forEach((item, index) => {
                        if (item.name == "publishDateAsString") {
                            filters[index].value = null;
                        }
                    });
                }
            }
            var searchData = {
                page: this.serverParams.page,
                pageSize: this.serverParams.pageSize,
                sort: this.serverParams.sort,
                columnFilters: filters,
            };
            HighlightModule.AssignSearchParams(searchData);
            this.machineService.send({
                type: "GETTING_HIGHLIGHTS",
                searchData: searchData,
            });
        }
        clearFilter() {
            this.selectedDate = null;
            this.serverParams.columnFilters = {};
            var ecgrid = this.$refs.ecgrid;
            ecgrid.$refs.grid.$refs["table-header-primary"].$refs["filter-row"].columnFilters = {};
            this.loadItems();
        }
        editHighlight(highlightId) {
            this.$router.push({ name: "EditHighlight", params: { highlightId: highlightId } });
        }
        removeHighlight(highlightId) {
            const isPageChanged = this.rows.length == 1 && this.serverParams.page != 1 ? true : false;
            this.highlightId = highlightId;
            this.machineService.send({
                type: "DELETE_HIGHLIGHT",
                ispageChanged: isPageChanged,
            });
        }
        deleteHighlight() {
            this.machineService.send({
                type: "DELETING_HIGHLIGHT",
                highlightId: this.highlightId,
            });
        }
        Archive(highlightId) {
            this.highlightId = highlightId;
            this.archiveModalTitle = "Are you sure you want to archive?";
            this.archivalStatus = true;
            this.machineService.send({
                type: "ARCHIVE_HIGHLIGHT",
            });
        }
        archiveUnArchiveHighlight() {
            this.machineService.send({
                type: "ARCHIVING_HIGHLIGHT",
                highlightId: this.highlightId,
                isArchived: this.archivalStatus,
            });
        }
        UnArchive(highlightId) {
            this.archivalStatus = false;
            this.archiveModalTitle = "Are you sure you want to unarchive?";
            this.highlightId = highlightId;
            this.machineService.send({
                type: "ARCHIVE_HIGHLIGHT",
            });
        }
        cancel() {
            this.machineService.send({
                type: "CANCEL",
            });
            this.$router.push({ name: "Highlights" });
        }
        get columnFilters() {
            var filters = [];
            Object.entries(this.serverParams.columnFilters).forEach(([key, value]) => {
                filters.push({
                    name: key,
                    value: value,
                });
            });
            return filters;
        }
        get isAnyFilterApplied() {
            return this.columnFilters.length != 0 && this.columnFilters.some((x) => x.value);
        }
        get rows() {
            return HighlightModule.highlights;
        }
        get totalHighlights() {
            return HighlightModule.totalCount;
        }
        get gridParams() {
            return HighlightModule.searchParams;
        }
        //Methods
        onRowClick(params) {
            var nodeClass = params.event.target.className;
            if (nodeClass != "vgt-left-align no-row-click" && nodeClass != "no-row-click") {
                this.$router.push({
                    name: "ViewHighlight",
                    params: { highlightId: params.row.id },
                });
            }
            console.log(nodeClass);
        }
        ViewHighlights(highlightId) {
            this.$router.push({ name: "ViewHighlight", params: { highlightId: highlightId } });
        }
        async beforeRouteEnter(to, from, next) {
            if (from.name != "EditHighlight" && from.name != "ViewHighlight") {
                HighlightModule.ClearSearchParams();
            }
            next();
        }
        initialize() {
            var value = HighlightModule.searchParams;
            if (value != null) {
                this.isPageIsDirty = true;
                this.initialPage = value.page;
                this.serverParams.pageSize = value.pageSize;
                if (value.columnFilters.length > 0) {
                    value.columnFilters.forEach((item) => {
                        this.serverParams.columnFilters[item.name] = item.value;
                    });
                }
                this.initialSortBy = value.sort;
            }
        }
        assignColumnFilters() {
            var ecgrid = this.$refs.ecgrid;
            var gridColumns = ecgrid.$refs.grid.$refs["table-header-primary"].$refs["filter-row"].columnFilters;
            if (this.gridParams && this.gridParams.columnFilters.length > 0) {
                this.gridParams.columnFilters.forEach((item) => {
                    this.isPageIsDirty = true;
                    if (item.name == "publishDateAsString") {
                        this.selectedDate = item.value;
                    }
                    gridColumns[item.name] = item.value;
                });
            }
        }
        created() {
            this.initialize();
            this.machineService.start();
            this.machineService.onTransition((state) => {
                var previousState = this.state;
                this.state = state;
                if (previousState.matches("idle") && this.state.matches("gettingHighlights")) {
                    var itemTypeColumn1 = this.columns.find((x) => x.field == "status");
                    if (itemTypeColumn1 && itemTypeColumn1.filterOptions.filterDropdownItems.length == 0) {
                        itemTypeColumn1.filterOptions.filterDropdownItems = this.statuses;
                    }
                    this.assignColumnFilters();
                }
                if (this.state.matches("deletingHighlight") || this.state.matches("archivingHighlight")) {
                    this.isGridLoading = true;
                }
                if (this.state.matches("loadedHighlight")) {
                    this.totalCount = this.totalHighlights;
                    this.isGridLoading = false;
                    this.isPageIsDirty = false;
                }
                if (this.state.matches("gettingHighlights") && previousState.matches("deletingHighlight")) {
                    if (this.state.context.ispageChanged) {
                        this.serverParams.page = this.serverParams.page - 1;
                    }
                }
            });
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    Highlights = __decorate([
        Component({
            name: "Highlights",
            components: {
                Layout,
                PageHeader,
                Loader,
                EcGrid,
                DeleteComponent,
            },
        })
    ], Highlights);
    return Highlights;
})();
export default Highlights;
